import React, { useState } from 'react';
import './Contact.css';
// Import your contact images
import facebook from '../images/Contacts/facebook.png';
import instagram from '../images/Contacts/instagram.png';
import linkedin from '../images/Contacts/linkedin.png';
import email from '../images/Contacts/mail.png';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Create mailto link with form data
    const subject = `Inquiry from ${formData.name} - ${formData.company}`;
    const body = `Name: ${formData.name}%0D%0AEmail: ${formData.email}%0D%0ACompany: ${formData.company}%0D%0A%0D%0AMessage:%0D%0A${formData.message}`;
    const mailtoLink = `mailto:inquiry@hunterdigitalmarketing.com?subject=${encodeURIComponent(subject)}&body=${body}`;
    window.location.href = mailtoLink;
  };

  const socialLinks = [
    {
      name: 'Email',
      icon: email,
      href: 'mailto:inquiry@hunterdigitalmarketing.com',
      color: '#EA4335'
    },
    {
      name: 'LinkedIn',
      icon: linkedin,
      href: 'https://www.linkedin.com/company/hunter-digital-marketing-solutions',
      color: '#0077B5'
    },
    {
      name: 'Instagram',
      icon: instagram,
      href: 'https://www.instagram.com/hunterdigital_/',
      color: '#E4405F'
    },
    {
      name: 'Facebook',
      icon: facebook,
      href: 'https://www.facebook.com/HunterDigitalMarketingSolutions',
      color: '#1877F2'
    }
  ];

  return (
    <section className="contact-section" id="contact">
      <div className="contact-container">
        <div className="contact-header">
          <h2 className="contact-title">Ready to Scale Your Business?</h2>
          <p className="contact-subtitle">
            Let's discuss how we can help transform your digital presence and drive real results.
          </p>
        </div>

        <div className="contact-layout">
          {/* Contact Form */}
          <div className="contact-form-section">
            <div className="form-header">
              <h3>Get in Touch</h3>
              <p>Tell us about your project and goals</p>
            </div>
            
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name">Full Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    placeholder="Your full name"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    placeholder="your@email.com"
                  />
                </div>
              </div>
              
              <div className="form-group">
                <label htmlFor="company">Company Name</label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  value={formData.company}
                  onChange={handleInputChange}
                  placeholder="Your company name (optional)"
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="message">Project Details *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  required
                  rows="5"
                  placeholder="Tell us about your project, goals, and how we can help..."
                ></textarea>
              </div>
              
              <button type="submit" className="submit-btn">
                <span>Send Message</span>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7 17L17 7M17 7H7M17 7V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </form>
          </div>

          {/* Contact Info */}
          <div className="contact-info-section">
            <div className="contact-info">
              <h3>Let's Start a Conversation</h3>
              <p>Ready to take your digital marketing to the next level? We're here to help you achieve your business goals.</p>
              
              <div className="contact-details">
                <div className="contact-item">
                  <div className="contact-item-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21 16.5C21 16.88 20.79 17.21 20.47 17.38L12.59 21.96C12.22 22.15 11.78 22.15 11.41 21.96L3.53 17.38C3.21 17.21 3 16.88 3 16.5V7.5C3 7.12 3.21 6.79 3.53 6.62L11.41 2.04C11.78 1.85 12.22 1.85 12.59 2.04L20.47 6.62C20.79 6.79 21 7.12 21 7.5V16.5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M7.5 4.21L12 6.81L16.5 4.21M12 6.81V17.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <div>
                    <h4>Email</h4>
                    <p>inquiry@hunterdigitalmarketing.com</p>
                  </div>
                </div>
                
                <div className="contact-item">
                  <div className="contact-item-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22S19 14.25 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9S10.62 6.5 12 6.5S14.5 7.62 14.5 9S13.38 11.5 12 11.5Z" fill="currentColor"/>
                    </svg>
                  </div>
                  <div>
                    <h4>Location</h4>
                    <p>Philippines</p>
                  </div>
                </div>
                
                <div className="contact-item">
                  <div className="contact-item-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 2C6.48 2 2 6.48 2 12S6.48 22 12 22S22 17.52 22 12S17.52 2 12 2ZM12 6C12.55 6 13 6.45 13 7S12.55 8 12 8S11 7.55 11 7S11.45 6 12 6ZM14 18H10C9.45 18 9 17.55 9 17S9.45 16 10 16H11V12H10C9.45 12 9 11.55 9 11S9.45 10 10 10H12C12.55 10 13 10.45 13 11V16H14C14.55 16 15 16.45 15 17S14.55 18 14 18Z" fill="currentColor"/>
                    </svg>
                  </div>
                  <div>
                    <h4>Response Time</h4>
                    <p>Within 24 hours</p>
                  </div>
                </div>
              </div>
              
              <div className="social-links">
                <h4>Connect With Us</h4>
                <div className="social-icons">
                  {socialLinks.map((link, index) => (
                    <a
                      key={index}
                      href={link.href}
                      target={link.name === 'Email' ? '_self' : '_blank'}
                      rel={link.name === 'Email' ? '' : 'noopener noreferrer'}
                      className="social-icon"
                      style={{ '--hover-color': link.color }}
                    >
                      <img src={link.icon} alt={link.name} />
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;